import { z } from 'zod';
const projectOutputEntitySchema = z.object({
    id: z.number(),
    name: z.string().min(1)
});
const projectOutputEntityToCreateSchema = projectOutputEntitySchema.omit({ id: true });
export { projectOutputEntitySchema, projectOutputEntityToCreateSchema };
//# sourceMappingURL=projectOutput.model.js.map